<template>
    <div class="main course">
        <Calendar ref="Calendar" :sundayStart="true" :markDate="arr" v-on:choseDay="clickDay" v-on:changeMonth="changeDate"></Calendar>
        <div class="course-container">
          <div v-for="classInfo in classInfos" :key="classInfo.id">
            <class-card v-bind:item="classInfo"></class-card>
          </div>
        </div>
        <the-tabbar></the-tabbar>
    </div>
</template>
<script>
import Vue from 'vue';
import { Field,Button,Toast,Popup,NavBar,Picker } from 'vant';
import TheTabbar from '@/components/TheTabbar';
import AppointmentCard from '@/components/AppointmentCard';
import ClassCard from '@/components/ClassCard';
import Calendar from '@/components/calendar-component/calendarStretch';
import moment from 'moment';
import Func from "@/assets/scripts/func";
moment.locale('zh-cn');

Vue.use(Field).use(Button).use(Toast).use(Popup).use(NavBar).use(Picker);

export default {
    name: 'CourseClassAlone',    
    data(){
        return {
            list: JSON.parse(localStorage.getItem('courseList')),   //课程信息 
            classInfos:JSON.parse(localStorage.getItem('courseList'))[moment(new Date()).format('YYYY/MM/DD')],   //初始值，当天课程信息
            month: moment(new Date()).format('YYYY/MM')
        }
    },
    components: {
        TheTabbar,Calendar,AppointmentCard,ClassCard
    },
    mounted(){
      this.init()      
    },
    methods: {
      clickDay(data) {
        //点击日期
        let courselist=JSON.parse(localStorage.getItem('courseList')) 
        var odata = moment(data).format('YYYY/MM/DD');  //转换日期格式        
        this.classInfos = [];   //课程信息清空
        //点击切换课程信息
        for(var tmp in courselist){
          if(odata == tmp){
            this.classInfos = courselist[odata];
          }
        }
      },
      changeDate(data) {
        //切换月份
        this.month = moment(data).format('YYYY/MM');  //月份赋值
        this.arr = [];   //课程日期清空
        this.classInfos = [];   //课程信息清空
      },
      init(){
        // console.log(this.arr)
        if(this.arr!=''){
          this.$refs.Calendar.ChoseMonth(this.arr[0])  //设置默认月份，默认有课程的月份
        }        
      }
    },
    computed:{
      arr:{
        get: function () {
          let courselist=JSON.parse(localStorage.getItem('courseList'))   //不能取data里面的list  类型不对
          // console.log(courselist)
          let newarr=[]        
          for(var tmp in courselist){
            // console.log(tmp)
            newarr.push(tmp); //课程日期
          }
          this.classInfos=courselist[newarr[0]]
          return newarr
        },
        set: function (newValue) {
          return newValue
        }
      }
    }
}
</script>
<style lang="less" scoped>
.course-container{
  padding: 0 .15rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/CourseClassAlone.vue